// export const baseUrl =
//   "https://bxge5lc56l.execute-api.ap-south-1.amazonaws.com/Prod";

// export const getToken = () => localStorage.getItem("token");



export const baseUrl =
  "https://bxge5lc56l.execute-api.ap-south-1.amazonaws.com/Prod";

const isLocal = process.env.NODE_ENV === "development";

const LOCAL_DEV_TOKEN = isLocal
  ? process.env.REACT_APP_DEV_TOKEN
  : null;

export const getToken = () => {
  return localStorage.getItem("token") || LOCAL_DEV_TOKEN;
};